export default __webpack_public_path__ + "static/media/folderIcon.26732b69.svg";